import * as actionTypes from "./ActionTypes"
// import { API } from "services/API"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const listsQualityDataUpdate = () => {
  return dispatch => {

    APIPost(UrlServer.URL_POST_QUALITY_DATA_FROM_IMPORT_GET,{}, datas => {
      dispatch({ type: actionTypes.LISTS_EMAIL_QUALITY_DATA_UPDATE, listsQualityData: datas.datas })
    })
  }
}
